import React, { useMemo, useCallback } from 'react'
import styled from '@emotion/styled'

import Modal from 'components/Modal'
import Switcher from './Switcher'

const MergeModal = ({
  className,
  doCancel,
  onClose,
  open,
  offset,
  targetTicket,
  ticket,
  hidden,
}) => {
  const styleContainerOpts = useMemo(
    () => ({
      maxHeight: `calc(100% - 120px)`,
      visibility: hidden ? 'hidden' : 'visible',
    }),
    [hidden]
  )

  const onBackgroundClick = useCallback(
    () => {
      if (targetTicket) doCancel()
      onClose()
    },
    [onClose, doCancel, targetTicket]
  )

  if (!open) return null

  return (
    <Modal
      onBackgroundClick={onBackgroundClick}
      offset={offset}
      contentClass={className}
      styleContainer={styleContainerOpts}
      noCurtain
    >
      <Switcher ticket={ticket} hidden={hidden} />
    </Modal>
  )
}

export default styled(MergeModal)`
  width: 350px;
`
